

function animateInnovators() {
  $('.block-innovators').each(function(index) {
    animateInnovator(this);
  });

}

function animateInnovator(innovator) {
  var $this = $(innovator);

  var $innovatorImage         = $this.find(".block-media");
  var $innovatorBlockContent  = $this.find(".block-content");
  var $innovatorBio  = $this.find(".innovator-bio");
  var $innovatorName          = $this.find(".innovator-name");
  var $innovatorRole          = $this.find(".innovator-role");
  var $innovatorProject       = $this.find(".innovator-project");
  var $innovatorQuote         = $this.find(".innovator-quote");

  TweenMax.set($innovatorImage, {opacity: 0});
  TweenMax.set($innovatorBio, {y: 50, opacity: 0});
  TweenMax.set($innovatorName, {y: 50, opacity: 0});
  TweenMax.set($innovatorRole, {y: 70, opacity: 0});
  TweenMax.set($innovatorProject, {y: 90, opacity: 0});
  TweenMax.set($innovatorQuote, {y: -50, opacity: 0});

  new ScrollMagic.Scene({triggerElement: innovator, triggerHook: 0.75, offset: 0, duration: "20%"})
  .setTween($innovatorImage, {opacity: 1, ease: Linear.easeNone})
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: innovator, triggerHook: 0.75, offset: 0, duration: "30%"})
  .setTween($innovatorBio, {y: 0, opacity: 1, ease: Linear.easeNone})
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: innovator, triggerHook: 0.5, offset: 0, duration: "30%"})
  .setTween([$innovatorName, $innovatorRole, $innovatorProject], {y: 0, opacity: 1, ease: Linear.easeNone})
  .addTo(controller);


  var innovatorTL  = new TimelineLite({paused: true});

  innovatorTL.to($innovatorQuote, 0.75, { y: 0, opacity: 1, ease: Linear.easeNone });

  var scene = new ScrollMagic.Scene({
    triggerElement: innovator,
    triggerHook: 0.5,
    offset: 0
  })
  .on('enter', function (event) {
    innovatorTL.play().timeScale(1);
  })
  .on('leave', function (event) {
    innovatorTL.reverse().timeScale(1.5);
  })
  .addTo(controller);



  var $innovatorOne           = $("#block-innovator-1");
  var $innovatorTwo           = $("#block-innovator-2");
  var $innovatorThree         = $("#block-innovator-3");

  TweenMax.set($innovatorTwo, {yPercent: 15});
  TweenMax.set($innovatorThree, {yPercent: 30});
  
  new ScrollMagic.Scene({triggerElement: innovator, offset: 0, duration: "100%"})
        .setTween($innovatorTwo, {yPercent: -15, ease: Linear.easeNone})
        .addTo(controller);

  new ScrollMagic.Scene({triggerElement: innovator, offset: 0, duration: "100%"})
        .setTween($innovatorThree, {yPercent: -30, ease: Linear.easeNone})
        .addTo(controller);

}